<template>
  <dam-layout>
    <base-heading>DAM: Credential page to be built</base-heading>
  </dam-layout>
</template>
<script>
import DamLayout from '../../layouts/DamLayout';
export default {
  name: 'CredentialsEdit',
  components: {
    DamLayout,
  },
};
</script>
